import React from 'react'
import Professionals from '../Pages/Professionals/Professionals'
import Navbar from '../LandingPage/Navbar/Navbar'
import Footer2 from '../Footer2/Footer2'
import TopBar from '../EdofSectionNew2/TopBar/TopBar'

const ProfessionalsPage = () => {
    return (
        <div >
            <TopBar/>
            <Navbar />
            <Professionals />
            <Footer2 />
        </div>
    )
}

export default ProfessionalsPage
